import { render, staticRenderFns } from "./otherModel.vue?vue&type=template&id=f58f4dd4&scoped=true&"
import script from "./otherModel.vue?vue&type=script&lang=js&"
export * from "./otherModel.vue?vue&type=script&lang=js&"
import style0 from "./otherModel.vue?vue&type=style&index=0&id=f58f4dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58f4dd4",
  null
  
)

export default component.exports